<script>
  import Button from '@components/Button.svelte';
  import BlockedUserAjax from '@ajax/blocked_user';
  import { getContext } from 'svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import Alert from '@components/Alert.svelte';
  let currentUser = getCurrentUserStore('default');

  export let user;
  let showAlert = false;
  const blockedUserIds = getContext('blockedUsers');

  const handleUnblock = async function () {
    let userId = user.id;
    try {
      await BlockedUserAjax.delete(userId);

      // Update the blockedUserIds store
      blockedUserIds.update((ids) => ids.filter((id) => id !== userId));
      currentUser.update((user) => ({
        ...user,
        blocked_user_count: Math.max((user.blocked_user_count || 1) - 1, 0),
      }));
    } catch (error) {
      console.error('Error unblocking user:', error);
      // Optionally, you can add error handling here (e.g., show a notification)
    }
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';
</style>

<div>
  <Alert
    on:yes-click={handleUnblock}
    question={`Are you sure you want to unblock ${user.name}?`}
    yesButtonText="Yes"
    cancelText="Cancel"
    objectText={null}
    bind:show={showAlert} />

  <Button colorScheme="black" text="Unblock" on:click={() => (showAlert = true)} />
</div>
